
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Eye, MoreHorizontal, Trash2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { RepairEstimateButton } from "./RepairEstimateButton";

interface VinRecordActionsProps {
  lookupId: string;
  onDelete?: (id: string) => void;
  onView: (lookup: any) => void;
  lookup: any;
}

export const VinRecordActions = ({ lookupId, onDelete, onView, lookup }: VinRecordActionsProps) => {
  const { toast } = useToast();

  const handleDelete = async (id: string) => {
    try {
      console.log('Deleting VIN lookup record:', id);
      const { error } = await supabase
        .from('vin_lookups')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Supabase delete error:', error);
        throw error;
      }

      toast({
        title: "Record deleted",
        description: "VIN lookup record has been removed",
      });

      if (onDelete) {
        onDelete(id);
      }
    } catch (error) {
      console.error('Error deleting record:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to delete the record. Please try again.",
      });
    }
  };

  const handleView = () => {
    // Directly call onView with the lookup data
    onView(lookup);
  };

  return (
    <div className="ml-4 flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={handleView}
        title="View vehicle details"
      >
        <Eye className="h-4 w-4" />
        <span className="sr-only">View details</span>
      </Button>
      
      <RepairEstimateButton vinLookupId={lookupId} />
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm">
            <MoreHorizontal className="h-4 w-4" />
            <span className="sr-only">Open options</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={handleView}>
            <Eye className="mr-2 h-4 w-4" />
            View
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => handleDelete(lookupId)} className="text-red-600 focus:text-red-600">
            <Trash2 className="mr-2 h-4 w-4" />
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
